import { generateName } from "@common/Common";
import { ValidationError } from "@common/types";

export class PortfolioProjectBuilderViewModel
{
    opened: boolean = false;

    name: string | null = null;
    description: string | null = null;
    creating: boolean = false;
    nameError: string | null = null;
    descriptionError: string | null = null;

    show()
    {
        this.name = generateName("Portfolio");
        this.description = null;
        this.creating = false;

        this.clearValidationErrors();

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.name = null;
        this.description = null;
        this.creating = false;

        this.clearValidationErrors();
    }

    displayValidationErrors(errors: ValidationError[])
    {
        this.creating = false;                

        for (const error of errors)
        {
            if (error.Context === "Name")
            {
                this.nameError = error.Error;
            }
            else if (error.Context === "Description")
            {
                this.descriptionError = error.Error;
            }
        }
    }

    clearValidationErrors()
    {
        this.nameError = null;
        this.descriptionError = null;
    }
}